import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const get_dashboard = async (dashboard) => {
  try {
    const data = {
      date: dashboard?.date,
      branch: dashboard?.branch,
      timezone: dashboard?.timezone,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-dashboard`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_products_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      unit: dashboard?.unit,
      category: dashboard?.category,
      brand: dashboard?.brand,
      type: dashboard?.type,
      status: dashboard?.status,
      branch: dashboard?.branch,
      page: dashboard?.page,
      limit: dashboard?.limit,
      source: dashboard?.source
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-products-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_products_low_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      unit: dashboard?.unit,
      category: dashboard?.category,
      brand: dashboard?.brand,
      type: dashboard?.type,
      status: dashboard?.status,
      branch: dashboard?.branch,
      page: dashboard?.page,
      limit: dashboard?.limit,
      source: dashboard?.source
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-products-low-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_products_out_of_stock_report = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      unit: dashboard?.unit,
      category: dashboard?.category,
      brand: dashboard?.brand,
      type: dashboard?.type,
      status: dashboard?.status,
      branch: dashboard?.branch,
      page: dashboard?.page,
      limit: dashboard?.limit,
      source: dashboard?.source
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-products-out-of-stock-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_inventories_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      product: dashboard?.product,
      supplier: dashboard?.supplier,
      purchase: dashboard?.purchase,
      branch: dashboard?.branch,
      date: dashboard?.date,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-inventories-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_inventories_near_expiry_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      unit: dashboard?.unit,
      category: dashboard?.category,
      brand: dashboard?.brand,
      type: dashboard?.type,
      status: dashboard?.status,
      date: dashboard?.date,
      product: dashboard?.product
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-inventories-near-expiry-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_inventories_expired_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      unit: dashboard?.unit,
      category: dashboard?.category,
      brand: dashboard?.brand,
      type: dashboard?.type,
      status: dashboard?.status,
      product: dashboard?.product,
      date: dashboard?.date
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-inventories-expired-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_sales_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      customer: dashboard?.customer,
      branch: dashboard?.branch,
      status: dashboard?.status,
      date: dashboard?.date,
      due_date: dashboard?.due_date,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-sales-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_net_sales_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      customer: dashboard?.customer,
      branch: dashboard?.branch,
      status: dashboard?.status,
      date: dashboard?.date,
      due_date: dashboard?.due_date,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      page: dashboard?.page,
      limit: dashboard?.limit,
      source: dashboard?.source
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-net-sales-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_purchase_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      supplier: dashboard?.supplier,
      product: dashboard?.product,
      branch: dashboard?.branch,
      status: dashboard?.status,
      date: dashboard?.date,
      due_date: dashboard?.due_date,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-purchase-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_fast_moving_products_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      unit: dashboard?.unit,
      category: dashboard?.category,
      brand: dashboard?.brand,
      type: dashboard?.type,
      status: dashboard?.status,
      branch: dashboard?.branch,
      date: dashboard?.date,
      timezone: dashboard?.timezone,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-fast-moving-products-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_products_ageing_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      unit: dashboard?.unit,
      category: dashboard?.category,
      brand: dashboard?.brand,
      type: dashboard?.type,
      status: dashboard?.status,
      branch: dashboard?.branch,
      date: dashboard?.date,
      timezone: dashboard?.timezone,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-products-ageing-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_products_received_ageing_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      unit: dashboard?.unit,
      category: dashboard?.category,
      brand: dashboard?.brand,
      type: dashboard?.type,
      status: dashboard?.status,
      branch: dashboard?.branch,
      date: dashboard?.date,
      timezone: dashboard?.timezone,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-products-received-ageing-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const download_all_products_reports_csv = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      unit: dashboard?.unit,
      category: dashboard?.category,
      brand: dashboard?.brand,
      type: dashboard?.type,
      status: dashboard?.status,
      branch: dashboard?.branch,
    };

    const token = localStorage.getItem("user");

    const response = await axios.post(
      `${APIURL}/download-all-products-reports-csv`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob", // <-- Important!
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error downloading CSV:", error);
    return null;
  }
};

const download_inventory_reports_csv = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      unit: dashboard?.unit,
      category: dashboard?.category,
      brand: dashboard?.brand,
      type: dashboard?.type,
      status: dashboard?.status,
      branch: dashboard?.branch,
    };

    const token = localStorage.getItem("user");

    const response = await axios.post(
      `${APIURL}/download-inventory-csv`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob", // <-- Important!
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error downloading CSV:", error);
    return null;
  }
};

const get_sales_tax_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      customer: dashboard?.customer,
      branch: dashboard?.branch,
      status: dashboard?.status,
      date: dashboard?.date,
      due_date: dashboard?.due_date,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-sales-tax-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_purchase_tax_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      supplier: dashboard?.customer,
      branch: dashboard?.branch,
      status: dashboard?.status,
      date: dashboard?.date,
      due_date: dashboard?.due_date,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-purchase-tax-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_vat_summary_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      supplier: dashboard?.customer,
      branch: dashboard?.branch,
      status: dashboard?.status,
      date: dashboard?.date,
      due_date: dashboard?.due_date,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-vat-summary-report`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_transfer_report = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      sort: dashboard?.sort,
      supplier: dashboard?.supplier,
      branch: dashboard?.branch,
      status: dashboard?.status,
      date: dashboard?.date,
      due_date: dashboard?.due_date,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-transfers-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};


const get_comprehensive_product_reports = async (dashboard) => {
  try {
    const data = {
      search: dashboard?.search,
      date: dashboard?.date,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-comprehensive-product-reports`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  get_dashboard,
  get_all_products_reports,
  get_all_products_low_reports,
  get_all_products_out_of_stock_report,
  get_all_inventories_reports,
  get_all_inventories_near_expiry_reports,
  get_all_inventories_expired_reports,
  get_net_sales_reports,
  get_sales_reports,
  get_purchase_reports,
  get_fast_moving_products_reports,
  get_products_ageing_reports,
  get_products_received_ageing_reports,
  download_all_products_reports_csv,
  download_inventory_reports_csv,
  get_sales_tax_reports,
  get_purchase_tax_reports,
  get_vat_summary_reports,
  get_transfer_report,
  get_comprehensive_product_reports
};
